import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取订单发货信息*/
export function GetDeliveryorder(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/deliveryorder/",
        params:data
    })
}

/*获取订单发货供应商信息*/
export function SupplierInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/optionssupplier/",
        params:data
    })
}

/*获取订单发货编辑信息*/
export function DeliveryorderEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/deliveryorderedit/",
        params:data
    })
}

/*获取发货明细编辑信息*/
export function DeliverystatisticsEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/deliverystatisticsedit/",
        params:data
    })
}

/*订单发货编辑*/
export function DeliveryorderEdit(data = {}){
    let params = new URLSearchParams();
    params.append('deliveryorderid',data.deliveryorderid);
    params.append('weightfee',data.weightfee);
    params.append('weight',data.weight);
    params.append('unitprice',data.unitprice);
    params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "ordermanage/deliveryorderedit/",
        data:params
    })
}

/*发货统计编辑*/
export function DeliverystatisticsEdit(data = {}){
    let params = new URLSearchParams();
    params.append('deliverydetailsid',data.deliverydetailsid);
    params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "ordermanage/deliverystatisticsedit/",
        data:params
    })
}

/*发货明细新增*/
export function DeliverydetailsAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/deliverydetailsadd/",
        data:data
    })
}

/*合并订单发货*/
export function DeliveryCombine(data={}){
    let params = new URLSearchParams();
    params.append('deliveryquantity',data.deliveryquantity);
    params.append('deliverysilverweight',data.deliverysilverweight);
    params.append('deliverydate',data.deliverydate);
    params.append('deliverynotes',data.deliverynotes);
    params.append('deliveryordernumber',data.deliveryordernumber);
return instance.request({
        method: "post",
        url: "ordermanage/deliverycombine/",
        data:params
    })
}

/*返修明细新增*/
export function RepairdetailsAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/repairdetailsadd/",
        data:data
    })
}

/*获取待发件数信息*/
export function PendingquantityInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/daifajianshu/",
        params:data
    })
}

/*获取下单日期信息*/
export function OrderdateInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/orderdateinfo/",
        params:data
    })
}

/*获取发货明细信息*/
export function DeliverydetailsInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/deliverydetails/",
        params:data
    })
}

/*获取发货附件信息*/
export function DeliveryattachmentInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/deliveryattachment/",
        params:data
    })
}


/*导出订单发货统计信息*/
export function ExportDeliveryStatistics(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/deliveryexport/",
        data:data,
        responseType: 'blob',
        timeout:30000
    })
}

/*上传发货附件*/
export function UploadDeliveryattachment(data = {}){
return instance.request({
        method: "post",
        url: "ordermanage/deliveryattachmentupload/",
        data:data
    })
}

/*发货附件删除*/
export function DeliveryattachmentDel(data = {}){
    let params = new URLSearchParams();
    params.append('deliveryattachmentid',data.deliveryattachmentid)
return instance.request({
        method: "post",
        url: "ordermanage/deliveryattachmentdel/",
        data:params
    })
}

/*发货明细删除*/
export function DeliverydetailsDel(data = {}){
    let params = new URLSearchParams();
    params.append('deliverydetailsid',data.deliverydetailsid)
return instance.request({
        method: "post",
        url: "ordermanage/deliverydetailsdel/",
        data:params
    })
}

/*获取返修明细信息*/
export function RepairdetailsInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/repairdetails/",
        params:data
    })
}

/*获取实发件数信息*/
export function ActualquantityInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/shifajianshu/",
        params:data
    })
}

/*返修明细删除*/
export function RepairdetailsDel(data = {}){
    let params = new URLSearchParams();
    params.append('repairdetailsid',data.repairdetailsid)
return instance.request({
        method: "post",
        url: "ordermanage/repairdel/",
        data:params
    })
}

/*获取寄货编辑信息*/
export function DeliverydetailsEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/deliverydetailsedit/",
        params:data
    })
}

/*寄货信息编辑*/
export function DeliverydetailsEdit(data = {}){
    let params = new URLSearchParams();
    params.append('deliverydetailsid',data.deliverydetailsid);
    params.append('notes',data.notes);
    params.append('sendquantity',data.sendquantity);
    params.append('senddate',data.senddate);
return instance.request({
        method: "post",
        url: "ordermanage/deliverydetailsedit/",
        data:params
    })
}

/*添加费用信息*/
export function CostrecordAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/costrecordadd/",
        data:data
    })
}

/*添加真钻费用信息*/
export function CostrecordDiamondAdd(data){
return instance.request({
        method: "post",
        url: "ordermanage/costrecordDiamondadd/",
        data:data
    })
}

/*获取费用记录信息*/
export function CostrecordInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/costrecord/",
        params:data
    })
}

/*费用记录信息删除*/
export function CostrecordDel(data = {}){
    let params = new URLSearchParams();
    params.append('costrecordid',data.costrecordid)
return instance.request({
        method: "post",
        url: "ordermanage/costrecorddel/",
        data:params
    })
}

/*费用编辑*/
export function CostEdit(data = {}){
    let params = new URLSearchParams();
    params.append('costrecordid',data.costrecordid);
    params.append('quantity',data.quantity);
    params.append('totalcost',data.totalcost);
    params.append('notes',data.notes);
return instance.request({
        method: "post",
        url: "ordermanage/costrecordedit/",
        data:params
    })
}

export function CostEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "ordermanage/costrecordedit/",
        params:data
    })
}